import store from '../../index'
import axios from 'axios'
import config from '../../../config/environment'
import queryString from 'query-string'
import RandomString from '../../../components/elements/randomString'
import { INIT } from './type'
import getMinMaxLimitsObj from '../../../components/Exchanger/elements/firstScreen/elements/function/getMinMaxLimitsObj'

import { loaderCurFromAction } from './action'

const { dispatch } = store

export default async function firstScreen() {

    const url = window.location.href
    const urlParamsString = url.slice((url.indexOf('?')) + 1)
    const urlParamsObj = queryString.parse(urlParamsString)

    let inCurrency, outCurrency, payway, amount, externalId, callbackUrl, email, outDestination, redirectUrl, exchangeWayId = null
    let editEmail, editOutDestination, editAmount = true

    if (urlParamsObj.cashbackToken && config.cashbackTokensArray.includes(urlParamsObj.cashbackToken)) {
        inCurrency = urlParamsObj.inCurrency || null
        outCurrency = urlParamsObj.outCurrency || null
        payway = urlParamsObj.payway || null
        amount = Number(urlParamsObj.amount) || null
        email = urlParamsObj.email || null
        outDestination = urlParamsObj.outDestination || null
        editEmail = email ? true : false
        editOutDestination = outDestination ? true : false
        editAmount = amount ? false : true
        exchangeWayId = urlParamsObj.exchangeWayId ? urlParamsObj.exchangeWayId : false
    }

    externalId = urlParamsObj.externalId || null
    callbackUrl = urlParamsObj.callbackUrl || null
    redirectUrl = urlParamsObj.redirectUrl || null

    let cashbackToken = '3NzM5RTg';
    const activeExchangeWays = (await axios.get(config.backendUrl + '/data/all')).data
    const allExchangeWays = [...activeExchangeWays.buy, ...activeExchangeWays.sell] // todo: add exchange here

    if (urlParamsObj.cur_from || urlParamsObj.cur_to) {
        cashbackToken = urlParamsObj.rid || null
        let res
        try {
            res = await axios.get(config.backendUrl + `/best-change/bc-to-trustee?cashbackToken=${cashbackToken}&currencyFrom=${urlParamsObj.cur_from}&currencyTo=${urlParamsObj.cur_to}`)
            res = res.data
        } catch (e) {
            console.log('error', e)
            dispatch(loaderCurFromAction(false))
        }
        inCurrency = res?.inCurrencyCode && typeof res?.inCurrencyCode !== 'undefined' && res?.inCurrencyCode !== 'undefined' ? res.inCurrencyCode : null
        outCurrency = res?.outCurrencyCode && typeof res?.outCurrencyCode !== 'undefined' && res?.outCurrencyCode !== 'undefined' ? res.outCurrencyCode : null

        const exchangeWay = allExchangeWays.find(way => way.inCurrency.code === inCurrency && way.outCurrency.code === outCurrency)
        payway = exchangeWay ? exchangeWay.exchangeWayType === 'SELL' ? res.outPaywayCode : res.inPaywayCode : null
        dispatch(loaderCurFromAction(false))
    } else {
        dispatch(loaderCurFromAction(false))
    }

    const locale = localStorage.getItem('locale') !== null ? localStorage.getItem('locale') : navigator.language || navigator.userLanguage

    if (urlParamsObj.cashbackToken) {
        cashbackToken = urlParamsObj.cashbackToken;
        localStorage.setItem('cashbackToken', urlParamsObj.cashbackToken);
    }
    let token = localStorage.getItem('cashbackToken')
    if (token && !config.cashbackTokensArray.includes(token)) {
        cashbackToken = localStorage.getItem('cashbackToken');
    }

    // if (process.env.NODE_ENV !== 'production' || process.env.REACT_APP_MODE !== 'DEV') {
    //     cashbackToken = cashbackToken
    // } else if (!config.cashbackTokensArray.includes(cashbackToken)) {
    //     cashbackToken = null
    // } else {
    //     cashbackToken = cashbackToken
    // }
    // }

    let swapCurrencyButtonName = null
    let exchangeWayType = null
    if (inCurrency && outCurrency) {
        const exchangeWay = allExchangeWays.find(way => way.inCurrency.code === inCurrency && way.outCurrency.code === outCurrency)
        swapCurrencyButtonName = exchangeWay ? exchangeWay.exchangeWayType === 'SELL' ? urlParamsObj.outCurrency : urlParamsObj.inCurrency : null
        exchangeWayType = exchangeWay ? exchangeWay.exchangeWayType : null
    }

    let minMaxLimits

    try {
        minMaxLimits = await getMinMaxLimitsObj(allExchangeWays, inCurrency, outCurrency, payway)
    } catch (e) {
        minMaxLimits = { min: 0, max: 0 }
    }

    let amountValid

    if (typeof minMaxLimits !== 'undefined') {
        if (amount < minMaxLimits.min || amount > minMaxLimits.max) {
            amountValid = true
        }
    } else {
        amountValid = false
    }

    const initAction = () => {
        return {
            type: INIT,
            screen: 1,
            userToken: RandomString.getString(10),
            allExchangeWays,
            locale: (locale.split('-'))[0],
            cashbackToken: cashbackToken,
            inCurrency: inCurrency,
            outCurrency: outCurrency,
            payway: payway,
            amount: Number(amount),
            swapCurrencyButtonName: swapCurrencyButtonName,
            minMaxLimits: minMaxLimits,
            exchangeWayType: exchangeWayType,
            outDestination: outDestination,
            email: email,
            externalId: externalId,
            callbackUrl: callbackUrl,
            editEmail: editEmail,
            editOutDestination: editOutDestination,
            amountValid: amountValid,
            redirectUrl: redirectUrl,
            editAmount,
            exchangeWayId
            // timerId
        }
    }

    dispatch(initAction())
}
